<template>


  <t-dialog-form :generalErrors="generalErrors" :title="t(command) + ' Item'"
                 :ok-text="t(command) + ' Item'" @show="showModal" @hidden="onClose" :busy="busy" :id="id"
                 :status="status" :command="command" :hide-submit="command === 'view'"
                 ref="dialog_form" @onSubmit="onSubmit">

    <template #default>

      <t-input v-model="form.checklistItemId" hidden/>

      <b-card-title class="mb-0">Inspeção Atual</b-card-title>

      <div class="p-2 pt-0">

        <t-input v-model="usingName" label="Item" required/>

        <t-input v-model="form.note" rows="2" enable-optimize-ai label="Descrição" max-length="2000" textarea/>


        <label>Condição atual</label>
        <b-radio-group required v-model="form.typeEstateItemStatusId">
          <div class="row">
            <div class="col-6">
              <div v-for="(item) in firstColumn" :key="item.typeEstateItemStatusId">
                <b-radio :value="item.typeEstateItemStatusId" :disabled="command === 'view'">
                  <span class="color-circle-small" :style="{'background-color': item.backgroundColor}"></span>
                  {{ item.name }}
                </b-radio>
              </div>
            </div>
            <div class="col-6">
              <div v-for="(item) in secondColumn" :key="item.typeEstateItemStatusId">
                <b-radio :value="item.typeEstateItemStatusId" :disabled="command === 'view'">
                  <span class="color-circle-small" :style="{'background-color': item.backgroundColor}"></span>
                  {{ item.name }}
                </b-radio>
              </div>
            </div>
          </div>
        </b-radio-group>


      </div>


      <b-card v-if="enableCompareChecklist" class="alert-warning">

        <b-card-title>Inspeção Anterior</b-card-title>

        <div v-if="objValid(oldTypeEstateItemStatus.name)">

          <label>Descrição anterior</label>
          <div class="mb-2" style="color: #000" v-if="form.oldNote !== ''"><b>{{form.originalTypeChecklistItem}}</b>  {{ form.oldNote }}</div>
          <div class="mb-2" style="color: #000" v-else>-</div>

          <label>Condição anterior</label>
          <div class="mb-2" style="color: #000">
            <span class="color-circle-small" :style="{'background-color': oldTypeEstateItemStatus.backgroundColor}"></span>
            <b>{{ oldTypeEstateItemStatus.name }}</b></div>

        </div>

        <div v-else>Este item não consta na inspeção anterior</div>


      </b-card>


    </template>


  </t-dialog-form>


</template>
<script>
import tDialogForm from "@/components/template/dialog/t-dialog-form";
import pageDialogFormMixin from "@/mixins/page/pageDialogFormMixin";
import SettingType from "@/model/types/resource/SettingType";
import TypeEstateItemStatusService from "@/services/modules/checklist/TypeEstateItemStatus.service";
import ui from "@/assets/scripts/ui";

export default {
  name: 'ChecklistEnvironmentItemFormDialog',
  components: {tDialogForm},
  mixins: [pageDialogFormMixin],
  data() {
    return {
      ui,
      SettingType,
      id: "modal-checklist-environment-item-form",
      path: "checklist/item", //Utilizar somente quando fora do padrão
      primaryKeyColumn: "checklistItemId",
      genKey: false, //Utilizar quando desejar gerar chave temporária
      enableGeneralFields: false,
      tabIndex: 0,
      form: {
        checklistItemId: this.primaryKey,
        changedName: "",
        typeEstateItemStatusId: 0,
        originalTypeChecklistItem: "", /*Nome original do item*/
        backupName: "",
        note: "",
        status: 1,
        oldNote: "",
        oldTypeEstateItemStatusId: 0,
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: ""
      },
      fieldsNotReset: [//Marca os nomes de colunas que não devem ser resetados
        this.foreignKeyColumn,
      ],
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      oldTypeEstateItemStatus: {},
      typeEstateStatusList: [],
      usingName: "",
      //--------------------------------------------------------------------------------------    
    }
  },
  props: {
    enableCompareChecklist: Boolean,
  },
  methods: {

    async mountedContinued() {

      this.pageFormIsLoaded = true

    },

    //Declaro sempre localmente, pois poderá realizar operações diferentes do padrão como setar algum valor padrão vindo de fora e que seria limpo pelo resetModal de forma dinamica
    async showModal() {

      this.busy = true

      //Limpa os campos
      this.resetModal()

      this.oldTypeEstateItemStatus = {}

      //Setar alguma informações padrão por exemplo vindo de fora
      this.form.checklistItemId = this.primaryKey
      this.form.status = 1

      await this.readModal(true)
      this.usingName = this.form.typeChecklistItem

      await TypeEstateItemStatusService.getAll().then((list) => {
        this.typeEstateStatusList = list

      }).catch(error => this.responseError(error))

      if (this.enableCompareChecklist && this.form.oldTypeEstateItemStatusId > 0) {

        //Busca o objeto completo antigo
        this.oldTypeEstateItemStatus = this.typeEstateStatusList.find(a => a.typeEstateItemStatusId === this.form.oldTypeEstateItemStatusId)

        if (this.oldTypeEstateItemStatus !== null) {

          //Seta a condição atual conforme a última somente para facilitar, porém não precisará confirmar
          if (this.form.typeEstateItemStatusId === 0 || this.form.typeEstateItemStatusId === undefined || this.form.typeEstateItemStatusId === null)
            this.form.typeEstateItemStatusId = this.oldTypeEstateItemStatus.typeEstateItemStatusId

          //Seta a condição atual conforme a última somente para facilitar, porém não precisará confirmar
          if (this.form.note === '' || this.form.note === undefined || this.form.note === null)
            this.form.note = this.form.oldNote

        }


      }


    },
    async onSubmit() {

      if (this.form.typeEstateItemStatusId === 0 || this.form.typeEstateItemStatusId === undefined || this.form.typeEstateItemStatusId === null) {
        ui.msg(this, "Informação", "Selecione o estado atual para continuar")
      } else {
        if (this.form.originalTypeChecklistItem !== this.usingName) {
          this.form.changedName = this.usingName
        } else {
          this.form.changedName = ""
        }

        //Validações específicas da tela
        await this.setSubmitDialogDefault()
      }


    },

    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela

    //--------------------------------------------------------------------------------------
  },
  computed: {
    firstColumn() {
      const half = Math.ceil(this.typeEstateStatusList.length / 2);
      return this.typeEstateStatusList.slice(0, half);
    },
    secondColumn() {
      const half = Math.ceil(this.typeEstateStatusList.length / 2);
      return this.typeEstateStatusList.slice(half);
    }
  }

}
</script>
